/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Courseid1Inputs */

const en__field_courseid1 = /** @type {(inputs: _Field_Courseid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course ID`)
};

/**
* | output |
* | --- |
* | "Course ID" |
*
* @param {_Field_Courseid1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_courseid1 = /** @type {((inputs?: _Field_Courseid1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Courseid1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_courseid1(inputs)
});
export { _field_courseid1 as "_field_courseId" }